import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { getBomType } from 'src/app/helpers';
import { ISort, ODataFilter } from 'src/app/lego-utils';
import { BOMItem } from 'src/app/models';
import { BOMItemDataService, IBOMItemDeleteOptions } from 'src/app/services';
import { CollectionState } from 'src/app/state/collection-state';
import { IPage } from 'src/app/state/paged-collection';
import { PagedSapService } from 'src/app/state/paged-sap-service';
import { upsertById } from 'src/app/state/upsert-by-id';

@Injectable({ providedIn: 'root' })
export class BOMItemService extends PagedSapService<
  BOMItem,
  Partial<BOMItem>,
  IBOMItemDeleteOptions
> {
  private readonly items = new CollectionState<BOMItem>();

  /**
   * Derived from every row loaded so far and rendered in material-bom's header. The
   * only reason this domain keeps a collection at all — the table itself binds the
   * `getPage()` result. See STEP-4D-PLAN.md.
   */
  public readonly bomType$ = this.items.items$.pipe(map(getBomType));

  public constructor(bomItemDataService: BOMItemDataService) {
    super(bomItemDataService);
  }

  /** Accumulates each page, as the paginator's `upsertMany` did, to feed `bomType$`. */
  public override getPage(
    page: number,
    perPage: number,
    sort?: Array<ISort<BOMItem>>,
    filters?: ODataFilter
  ): Observable<IPage<BOMItem>> {
    return super.getPage(page, perPage, sort, filters).pipe(
      tap(({ data }) => {
        this.items.set(upsertById(this.items.items, data));
      })
    );
  }

  public resetStore() {
    this.items.reset();
  }
}
